import React from 'react';
import OrderDirectionsEnum from '../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../Enums/ShownPanelsEnum';
import orderByHelper from '../../Helpers/orderByHelper';
import ErrorMessage from '../ErrorMessage';
import Loading from '../loading';
import Pagination from '../Pagination';
import GeneralSearchStrip from '../GeneralSearchStrip';
import AcceleratedDataTable from './AcceleratedDataTable';
import MultiPageSelector from '../MultiPageSelector';
import urlHelper from '../../Helpers/urlHelper';
import columnVisibilityHelper from '../../Helpers/columnVisibilityHelper';

export default class TabOfDataTable extends React.Component {
  static defaultProps = {
    type: null,
    shownPanel: ShownPanelsEnum.None,
    orderDirection: OrderDirectionsEnum.Asc,
    serviceFunction: null,
    convertDBItemsFunction: null,
    renderActionButtonRow: null,
    cleared: false,
    popupEnabled: true,
    orderBy: 'Id',
    showSearchStrip: false,
    showPagination: true,
    isRefreshDisabled: false,
    isFilterDisabled: false,
    isExportExcelDisabled: true,
    clickOnExportExcel: () => alert('Please, create a export excel function!'), // Only needed if the excel report is enabled
    searchParamsType: null,
    clickOnStartSearch: null,
    itemList: [],
    changeOfItemListFunction: null,
    enableUrlPush: true,
    maxShownItem: undefined,
    numberOfElementsOnAPage: 20,
    changeOfAllItemsAreSelectedFunction: null,
    isSelectAllDisabled: false,
    itemTypeName: 'items',
    ModalFeature: false,
    singleSearchLine: false,
    singleSearchLinePlaceholder: 'Search...',
    errorCode: 'TODT152',
    forceClearCacheOnSearch: false,
    excelExportRoleKey: null, // ButtonRowButton type role key for excel export
    excelExportTooltipMessage: 'Export Excel based on filter', // Only needed if the excel report is enabled and a custom tooltip is needed
    useClickOnClearAll: false,
    // Selection normally lives on the item objects of the page currently loaded, so paging away
    // silently drops every tick. A page that acts on the selection across pages turns the flag on
    // and the grid keeps it, keyed by the item type's own id field - nothing about the retention
    // itself is configured from the outside. Off leaves every existing list as it was.
    retainSelectionAcrossPages: false,
    changeOfSelectionFunction: null, // (selectedItems) => void, called with the kept item objects
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      loading: true,
      selected: -1,
      orderBy: props.orderBy,
      orderDirection: props.orderDirection,
      pageNumber: 1,
      numberOfElementsOnAPage: this.props.numberOfElementsOnAPage,
      numberOfElementsInTheTable: 0,
      searchItem: props.searchItem,
      allItemsAreSelected: false,
      hiddenColumns: columnVisibilityHelper.readHiddenColumns(props.type),
    };
    // Kept selection: key -> the item object, so a caller reading it also sees each row's current
    // data. The entry is replaced with the freshly loaded object whenever the row is on a page
    // that gets loaded again.
    this.retainedSelection = new Map();
    // Without an id field the selection would quietly fall back to the page currently loaded, which
    // is the defect the retention exists to prevent, so say so instead of degrading in silence.
    if (props.retainSelectionAcrossPages && this.selectionKeyFieldName() === null) {
      ErrorMessage.LogDevInfo(
        'The selection cannot be kept across pages: the item type declares no NameOfTheIdField().',
        'TabOfDataTable'
      );
    }
    this.escFunction = this.escFunction.bind(this);
    this.refresh = this.refresh.bind(this);
    this.clearRetainedSelection = this.clearRetainedSelection.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.toggleColumn = this.toggleColumn.bind(this);
    this.resetColumns = this.resetColumns.bind(this);
    this.setAllItemsAreSelected = this.setAllItemsAreSelected.bind(this);
    this.shellRef = React.createRef();
    this.adjustTableHeight = this.adjustTableHeight.bind(this);

    //The clickOnSelect needs to be binded here for the allItemsAreSelected variable to be in sync with the parent component
    if (
      (props.isSelectAllDisabled ||
        props.changeOfAllItemsAreSelectedFunction !== null ||
        props.retainSelectionAcrossPages) &&
      props.type.clickOnSelect !== undefined
    ) {
      props.type.clickOnSelect = this.clickOnSelect.bind(this);
      props.type.clickOnGlobalSelect = this.clickOnGlobalSelect.bind(this);
      props.type.selectedStatus = this.selectedStatus.bind(this);
    }
  }

  componentDidMount() {
    if (this.props.cleared === false) {
      this.populateItemListData(
        this.state.orderBy,
        this.state.orderDirection,
        this.state.pageNumber,
        this.state.numberOfElementsOnAPage,
        this.props.searchItem,
        this.props.forceClearCacheOnSearch
      );
    } else {
      this.setState({ loading: false });
    }
    document.addEventListener('keydown', this.escFunction, false);
    window.addEventListener('resize', this.adjustTableHeight);
    // Fit on mount too — inside the detail popup the layout settles after this component mounts.
    requestAnimationFrame(this.adjustTableHeight);
  }

  componentDidUpdate(prevProps) {
    requestAnimationFrame(this.adjustTableHeight);
    if (this.state.searchItem !== this.props.searchItem || this.props.maxShownItem !== prevProps.maxShownItem) {
      if (this.state.searchItem !== this.props.searchItem) {
        // A new search (including clear-all and the parent's refresh) produces a different result
        // set, so a selection made against the old one must not survive it.
        this.clearRetainedSelection();
      }
      if (!this.props.cleared) {
        this.populateItemListData(
          this.state.orderBy,
          this.state.orderDirection,
          1,
          this.state.numberOfElementsOnAPage,
          this.props.searchItem,
          this.props.forceClearCacheOnSearch
        );
      } else if (this.props.cleared) {
        this.setState({ itemList: [] });
      }
      return;
    }
    if (prevProps.itemList !== this.props.itemList) {
      this.setState({ itemList: this.props.itemList });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    window.removeEventListener('resize', this.adjustTableHeight);
  }

  // Fit the list so it scrolls internally (sticky header at top, pagination just below) with no
  // page-level scroll or grey gap — or, when the list is empty / loading, fill the .empty-state /
  // .loading block so its content centers in the full area. Applies to full-page lists (rendered as
  // a direct child of .contentwrapper) AND to lists embedded in the detail popup (.verticalScroll),
  // where it fits the popup's scroll area instead of the viewport. Other embedded tables are left at
  // natural height. Reads real geometry, so it is immune to the legacy .MenuButtonList overlay hack
  // that breaks a pure-CSS flex chain, and to the varied admin-page wrappers inside the popup.
  adjustTableHeight() {
    const shell = this.shellRef.current;
    if (!shell) return;
    // In the detail popup the bounding scroll area is .verticalScroll; on full pages it is the
    // viewport. A .grid-fit-bounds ancestor bounds the fit tighter than either — used by pages
    // that stack several grids (e.g. Fraud Hit Details' half-and-half split), where each grid
    // must fill its pane instead of the viewport. Bail for any other embedded context (no popup,
    // no bounds, not a full-page .contentwrapper list).
    const fitBounds = shell.closest('.grid-fit-bounds');
    const popupScroller = shell.closest('.verticalScroll');
    const inContentWrapper = !!shell.parentElement && shell.parentElement.classList.contains('contentwrapper');
    if (!fitBounds && !popupScroller && !inContentWrapper) return;
    const target =
      shell.querySelector('.table-wrap') || shell.querySelector('.empty-state') || shell.querySelector('.loading');
    if (!target) return;
    // Re-measuring drops the fixed height, which momentarily removes the internal overflow and
    // makes the layout flush below clamp scrollTop to 0. This runs on every componentDidUpdate
    // (e.g. a row-checkbox click), so without restoring scrollTop at the end a scrolled list
    // snaps back to the top on any re-render.
    const scrollTop = target.scrollTop;
    target.style.height = '';
    const targetTop = target.getBoundingClientRect().top;
    const below = shell.getBoundingClientRect().bottom - target.getBoundingClientRect().bottom;
    // Math.floor so sub-pixel getBoundingClientRect values can't push the shell 1px past the
    // bottom reference (which would show a scrollbar on the empty-state / loading block, which has
    // no internal overflow of its own). `below` already includes the pagination foot, so it stays
    // visible just under the fitted table.
    const bottomRef = fitBounds
      ? fitBounds.getBoundingClientRect().bottom
      : popupScroller
      ? popupScroller.getBoundingClientRect().bottom
      : window.innerHeight;
    const available = Math.floor(bottomRef - targetTop - below);
    if (available > 160) {
      target.style.height = `${available}px`;
      // The pane, not the page, is a bounded grid's limit — skip the page-level overflow
      // self-correct below, which would wrongly shrink this grid while a sibling grid is
      // still unfitted. When a bounded grid's height changes it shifts everything below it;
      // the hosting page keeps siblings in sync with a ResizeObserver on the pane that
      // dispatches a window resize (see FraudHitDetails / FRONTEND.md).
      if (!fitBounds) {
        // Self-correct for any residual vertical overflow of the scroll container — the popup's
        // .verticalScroll, or on full pages the legacy .contentwrapper (position:relative; top:80px)
        // adds ~80px on tabbed pages, which an exact fill would otherwise expose as a scrollbar.
        const scroller = popupScroller || shell.closest('.Basecontent');
        if (scroller) {
          const overflow = scroller.scrollHeight - scroller.clientHeight;
          if (overflow > 0) target.style.height = `${Math.max(160, available - overflow)}px`;
        }
      }
    }
    target.scrollTop = scrollTop;
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selected: -1,
        selectedItem: null,
      });
    }
  }

  setAllItemsAreSelected(allItemsInTheSearchSetAreSelected) {
    this.setState({ allItemsAreSelected: allItemsInTheSearchSetAreSelected });
    if (this.props.changeOfAllItemsAreSelectedFunction) {
      this.props.changeOfAllItemsAreSelectedFunction(allItemsInTheSearchSetAreSelected);
    }
  }

  // The row identity across pages is taken from the item type itself - every list item class names
  // its own id field - so a page asking for the selection never hands over a key function.
  selectionKeyFieldName() {
    return this.props.type != null && typeof this.props.type.NameOfTheIdField === 'function'
      ? this.props.type.NameOfTheIdField()
      : null;
  }

  isSelectionRetained() {
    return this.props.retainSelectionAcrossPages && this.selectionKeyFieldName() !== null;
  }

  selectionKeyOf(item) {
    return item[this.selectionKeyFieldName()];
  }

  retainSelectionOfItem(item, selected) {
    const key = this.selectionKeyOf(item);
    if (selected) {
      this.retainedSelection.set(key, item);
    } else {
      this.retainedSelection.delete(key);
    }
  }

  notifyOfSelectionChange() {
    if (this.props.changeOfSelectionFunction) {
      this.props.changeOfSelectionFunction([...this.retainedSelection.values()]);
    }
  }

  // Drops the kept selection and unticks whatever of it is currently loaded. Used when the search
  // changes (the result set the selection belonged to is gone) and by the selection bar's clear
  // button. Re-rendering is left to the caller, so this stays safe to call from componentDidUpdate.
  clearRetainedSelection() {
    if (!this.isSelectionRetained()) return;
    this.retainedSelection = new Map();
    this.state.itemList.forEach((item) => (item.Selected = false));
    // "All items in this set" belongs to the result set being dropped as well; left on, the next
    // load would tick its whole first page and report the new set as fully selected.
    if (this.state.allItemsAreSelected) {
      this.setAllItemsAreSelected(false);
    }
    this.notifyOfSelectionChange();
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    // clickOnSelect is bound onto the item type, which every grid of that type shares, so a tick in
    // another grid of the same type (e.g. one inside a popup) arrives here too. Only rows of this
    // grid belong in its kept selection.
    if (this.isSelectionRetained() && this.state.itemList.includes(item)) {
      this.retainSelectionOfItem(item, selected);
      this.notifyOfSelectionChange();
    }
    this.setState({ itemList: [...this.state.itemList] });
    this.setAllItemsAreSelected(false);
  }

  clickOnGlobalSelect(item, selected) {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);
    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    if (this.isSelectionRetained()) {
      templist.forEach((c) => this.retainSelectionOfItem(c, selectedStatus));
      this.notifyOfSelectionChange();
    }
    this.setState({ itemList: templist });
    this.setAllItemsAreSelected(false);
  }

  selectedStatus() {
    if (this.state.itemList.some((x) => x.Selected === false)) {
      return false;
    }

    return true;
  }

  changeOrderBy(orderById) {
    const newOrderDir = orderByHelper.newOrderByDirection(this.state.orderBy, orderById, this.state.orderDirection);
    this.setState({
      selected: -1,
      selectedItem: null,
      orderBy: orderById,
      orderDirection: newOrderDir,
      pageNumber: 1,
    });
    this.populateItemListData(
      orderById,
      newOrderDir,
      1,
      this.state.numberOfElementsOnAPage,
      this.props.searchItem,
      this.props.forceClearCacheOnSearch
    );
  }

  populateItemListData(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    this.setState({ loading: true, searchItem });

    const sanitizedSearchItem = { ...searchItem };
    //Sanitize string values
    Object.keys(sanitizedSearchItem).forEach((key) => {
      if (typeof sanitizedSearchItem[key] === 'string') {
        sanitizedSearchItem[key] = encodeURIComponent(sanitizedSearchItem[key]);
      }
    });

    this.props
      .serviceFunction(orderById, orderDir, pageNumber, numberOfElements, sanitizedSearchItem, clearCache)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ loading: false });
          return;
        }

        if (result.warning) {
          ErrorMessage.SetErrorMessage(
            result.warning + ' Please contact IT with details on where you encountered this message.'
          );
          this.setState({ loading: false });
          return;
        }

        let convertedResult;
        try {
          let data = result.data ? result.data : result;
          if (!data) data = [];
          convertedResult = this.props.convertDBItemsFunction(data);
        } catch (error) {
          ErrorMessage.LogDevInfo(error, ErrorMessage.EveryWhere);
          if (!clearCache) {
            ErrorMessage.LogDevInfo(result, `${this.props.errorCode} with reload`, ErrorMessage.EveryWhere);
            ErrorMessage.LogDevInfo('Reload...', ErrorMessage.EveryWhere);
            this.props.serviceFunction(orderById, orderDir, pageNumber, numberOfElements, sanitizedSearchItem, true);
            return;
          }
          ErrorMessage.SetErrorMessage(`TODT165 - ${this.props.errorCode}`, error);
          throw Error(error);
        }
        if (this.props.maxShownItem) {
          convertedResult = [...convertedResult].sort((a, b) => b - a).slice(0, this.props.maxShownItem);
        }
        if (this.isSelectionRetained()) {
          // The conversion builds brand new item objects with Selected = false, so a row that is
          // part of the kept selection has to be reticked - and the kept copy replaced with the
          // fresh one, so the caller reads the row's current status and not the one it had when it
          // was picked. While "all items in this set" is on, every row of a newly loaded page is
          // part of the selection by definition, so it is ticked and kept too: the bar keeps
          // reporting the whole set, and unticking one row leaves the rest of the page selected
          // exactly as shown.
          convertedResult.forEach((item) => {
            const key = this.selectionKeyOf(item);
            if (this.state.allItemsAreSelected || this.retainedSelection.has(key)) {
              item.Selected = true;
              this.retainedSelection.set(key, item);
            }
          });
        }
        this.setState({
          itemList: convertedResult,
          loading: false,
          pageNumber: result.pageNumber,
          numberOfElementsInTheTable:
            result.numberOfElementsInTheTable != null ? result.numberOfElementsInTheTable : convertedResult.length,
          selected: -1,
          selectedItem: null,
        });
        if (this.isSelectionRetained()) {
          this.notifyOfSelectionChange();
        }
        if (this.props.changeOfItemListFunction !== null) {
          this.props.changeOfItemListFunction(convertedResult, result.numberOfElementsInTheTable, result.pageNumber);
        }
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage(this.props.errorCode, error);
        this.setState({ loading: false });
      });
  }

  clickOnPagination(pageNumber) {
    this.populateItemListData(
      this.state.orderBy,
      this.state.orderDirection,
      pageNumber,
      this.state.numberOfElementsOnAPage,
      this.props.searchItem,
      this.props.forceClearCacheOnSearch
    );
  }

  startSearch(searchItem) {
    // A search started from the search strip sets state.searchItem here and only then tells the
    // page, so componentDidUpdate never sees the two differ and cannot drop the kept selection -
    // it has to happen here, or rows picked under the previous search would stay selected
    // invisibly and be acted on by the next action.
    this.clearRetainedSelection();
    this.setState({
      searchItem,
      pageNumber: 1,
    });
    this.populateItemListData(
      this.state.orderBy,
      this.state.orderDirection,
      1,
      this.state.numberOfElementsOnAPage,
      searchItem,
      this.props.forceClearCacheOnSearch
    );
    if (this.props.clickOnStartSearch) this.props.clickOnStartSearch(searchItem);
  }

  refresh() {
    this.populateItemListData(
      this.state.orderBy,
      this.state.orderDirection,
      this.state.pageNumber,
      this.state.numberOfElementsOnAPage,
      this.state.searchItem,
      true
    );
  }

  clearAll() {
    const searchItem = new this.props.searchParamsType();
    searchItem.ClearAll();
    if (this.props.enableUrlPush) {
      urlHelper.addSearchParamsToUrl(searchItem);
    }
    this.props.clickOnStartSearch(searchItem);
  }

  toggleColumn(key) {
    const next = new Set(this.state.hiddenColumns);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    this.setState({ hiddenColumns: next });
    columnVisibilityHelper.writeHiddenColumns(this.props.type, next);
  }

  resetColumns() {
    columnVisibilityHelper.clearHiddenColumns(this.props.type);
    this.setState({ hiddenColumns: new Set() });
  }

  renderSearchStrip() {
    return (
      this.props.showSearchStrip && (
        <GeneralSearchStrip
          searchItem={this.state.searchItem}
          resultCount={this.state.numberOfElementsInTheTable}
          isRefreshDisabled={this.props.isRefreshDisabled}
          isFilterDisabled={this.props.isFilterDisabled || !this.props.searchParamsType}
          isExportExcelDisabled={this.props.isExportExcelDisabled}
          excelExportRoleKey={this.props.excelExportRoleKey}
          searchParamsType={this.props.searchParamsType}
          clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          clickOnOk={(type, item) => this.startSearch(item)}
          clickOnRefresh={this.refresh}
          clickOnClearAll={this.clearAll}
          clickOnExportExcel={this.props.clickOnExportExcel}
          enableUrlPush={this.props.enableUrlPush}
          singleSearchLine={this.props.singleSearchLine}
          singleSearchLinePlaceholder={this.props.singleSearchLinePlaceholder}
          excelExportTooltipMessage={this.props.excelExportTooltipMessage}
          useClickOnClearAll={this.props.useClickOnClearAll}
          columns={columnVisibilityHelper.getSelectableColumns(this.props.type)}
          hiddenColumns={this.state.hiddenColumns}
          onToggleColumn={this.toggleColumn}
          onResetColumns={this.resetColumns}
        />
      )
    );
  }

  renderMultiPageSelector() {
    return !this.props.isSelectAllDisabled && this.props.changeOfAllItemsAreSelectedFunction !== null ? (
      <MultiPageSelector
        allItemsAreSelected={this.state.allItemsAreSelected}
        setAllItemsAreSelected={(state) => {
          this.setAllItemsAreSelected(state);
        }}
        itemList={this.state.itemList}
        numberOfElements={this.state.numberOfElementsInTheTable}
        itemTypeName={this.props.itemTypeName}
        numberOfElementsOnAPage={this.state.numberOfElementsOnAPage}
        numberOfSelectedItems={this.isSelectionRetained() ? this.retainedSelection.size : null}
        clearSelection={
          this.isSelectionRetained()
            ? () => {
                this.clearRetainedSelection();
                this.setState({ itemList: [...this.state.itemList] });
                this.setAllItemsAreSelected(false);
              }
            : null
        }
      />
    ) : null;
  }

  paginationOnChangeOfRangeSelectorHandler(newRange) {
    this.setState({
      numberOfElementsOnAPage: newRange,
    });
    this.populateItemListData(
      this.state.orderBy,
      this.state.orderDirection,
      this.state.pageNumber,
      newRange,
      this.state.searchItem,
      this.props.forceClearCacheOnSearch
    );
  }

  render() {
    return (
      <div ref={this.shellRef}>
        {this.state.loading ? (
          <Loading />
        ) : (
          <div>
            {this.renderSearchStrip()}
            {this.renderMultiPageSelector()}
            <div className={this.props.className}>
              <AcceleratedDataTable
                itemList={this.state.itemList}
                orderBy={this.state.orderBy}
                orderDirection={this.state.orderDirection}
                changeOrderBy={(orderById) => this.changeOrderBy(orderById)}
                type={this.props.type}
                getItemTypeFunction={this.props.getItemTypeFunction}
                selected={this.state.selected}
                selectable={this.state.shownPanel === ShownPanelsEnum.None}
                popupEnabled={this.props.popupEnabled}
                redirectLinkOnInfo={this.props.redirectLinkOnInfo}
                rerender={this.props.changeOfItemListFunction !== null}
                ModalFeature={this.props.ModalFeature}
                afterClickOnCancel={this.props.afterClickOnCancel}
                hiddenColumns={this.state.hiddenColumns}
              />
              {this.props.showPagination && (
                <Pagination
                  pageNumber={this.state.pageNumber}
                  numberOfElementsInTheTable={this.state.numberOfElementsInTheTable}
                  numberOfElementsOnThePage={this.state.numberOfElementsOnAPage}
                  onClick={(pageNumberInPagination) => this.clickOnPagination(pageNumberInPagination)}
                  rangeMax={500}
                  onChangeOfRangeSelector={this.paginationOnChangeOfRangeSelectorHandler.bind(this)}
                  itemTypeName={this.props.itemTypeName}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
